import { v4 as uuidv4 } from 'uuid';

// const uuid = uuidv4().replace(/-/g,'');
// console.log(uuid);
// console.log('uuid');


export const detUUID = () => {
    return uuidv4().replace(/-/g, '');
}


export const getTimeZoneToDay = (timestamp = '', format = 'YYYY-MM-DD') => {
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const date = new Date(timestamp);

    // 检查日期是否有效
    if (isNaN(date.getTime())) {
        return '';
    }

    switch (format) {
        case 'YYYY-MM-DD':
            return formatToYYYYMMDD(date, timeZone);
        case 'MMM D, YYYY':
            return formatToMMMDYYYY(date, timeZone);
        case 'MMM DD, YYYY':
            return formatToMMMDDYYYY(date, timeZone);
        case 'MMMM D, YYYY':
            return formatToMMMMDYYYY(date, timeZone);
        case 'D MMM YYYY':
            return formatToDMMMYYYY(date, timeZone);
        case 'DD/MM/YYYY':
            return formatToDDMMYYYY(date, timeZone);
        default:
            return formatToYYYYMMDD(date, timeZone);
    }
}

// 格式化函数
const formatToYYYYMMDD = (date, timeZone) => {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: timeZone
    };

    const formatter = new Intl.DateTimeFormat('en-CA', options); // en-CA 使用 YYYY-MM-DD 格式
    return formatter.format(date);
};

const formatToMMMDYYYY = (date, timeZone) => {
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: timeZone
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(date);
};

const formatToMMMDDYYYY = (date, timeZone) => {
    const options = {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        timeZone: timeZone
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(date);
};

const formatToMMMMDYYYY = (date, timeZone) => {
    const options = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: timeZone
    };

    const formatter = new Intl.DateTimeFormat('en-US', options);
    return formatter.format(date);
};

const formatToDMMMYYYY = (date, timeZone) => {
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: timeZone
    };

    const formatter = new Intl.DateTimeFormat('en-GB', options); // en-GB 使用 D MMM YYYY 格式
    return formatter.format(date);
};

const formatToDDMMYYYY = (date, timeZone) => {
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: timeZone
    };

    const formatter = new Intl.DateTimeFormat('en-GB', options); // en-GB 使用 DD/MM/YYYY 格式
    return formatter.format(date);
};
export const getTimeZone = (timestamp = '', second = '') => {



    if (timestamp == '') {
        return ''
    }
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


    const date = new Date(timestamp);

    let options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZone: timeZone
    }

    if (second) {
        options.second = '2-digit'
    }

    const formatter = new Intl.DateTimeFormat(navigator.language, options);

    const formattedDate = formatter.format(date);
    return formattedDate

}



export const getPublicKey = () => {
    return `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAjL04guzIPdkiBR97Pdz/b6s95XIHVkZMg6kXxr3YXxUGZtUajW4CdlY3hLZ/dAx6omUlGoJoXWBE8Wsv4dBQRm0gk1Gdnvq8kzMZ8iiOivdoCk/Wn+jgeBKJoLKuKDfyPn5PdRLf9O5XZsl1XcJW+9dgKlOV9LrcZWCuii8sgEigkej+8kLTHBxuo0N3i5Ga/sUp2vgEBIjeAPyiecsNhV7iNy4r9v1cbkFzh9WJT2bNaZXV2234gtMr5P+VeqoBa4NnlJVU+b+T2MtY6VIGG5X+jZtMHJnUu4uwup6r+Iklqg80HbGHJ0DOO3cdmXm139oIkbko5tWf5teNyoZ3XQIDAQAB
-----END PUBLIC KEY-----`
}


export const isMobileDevice = () => {
    return /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

export const gtag_report_conversion = (url = undefined) => {
    var callback = function (r) {
        if (typeof url != "undefined") {
            window.location = url;
        }
    };
    gtag("event", "conversion", {
        send_to: "AW-16732332089/1bafCKDt494ZELnAzKo-",
        event_callback: callback,
    });
    return false;
};

function isJsonCodeBlock(text) {
    // 判断是否以 ```json 开头，``` 结尾
    const regex = /^```json.*```$/;
    return regex.test(text);
}
function removeJsonCodeBlock(text) {
    // 使用正则表达式匹配以 ```json 开头，``` 结尾的文本并移除
    return text.replace(/^```json|```$/g, '').trim();
}
export const isJsonStringObject = (str) => {
    try {
        if (isJsonCodeBlock(str)) {
            str = removeJsonCodeBlock(str)
        }
        console.log(str)

        const parsed = JSON.parse(str);
        return parsed
    } catch (e) {
        return false;
    }
}
export const isNotEmpty = (value) => {
    if (value === null || value === undefined) return false; // null 或 undefined
    if (typeof value === 'string' && value.trim() === '') return false; // 空字符串（包括空格）
    if (typeof value === 'object' && Object.keys(value).length === 0) return false; // 空对象
    return true; // 非空
}

export const getContentBetweenChars = (url) => {
    // 使用正则表达式提取需要的部分
    const regex = /\/([a-f0-9]{32})(?=\/)/; // 假设需要提取的是32个十六进制字符
    const match = url.match(regex);

    return match ? match[1] : ''; // 返回匹配的内容或空字符串
}

export const getFileExtension = (fileName) => {

    return fileName
        .slice(((fileName.lastIndexOf(".") - 1) >>> 0) + 2)
        .toLowerCase();
}
export const initJSONData = () => {
    return {

        // 将 Delta 转换为自定义 HTML
        convertDeltaToCustomHTML: (delta, insert, type) => {
            let html = '';
            console.log()
            delta.ops.forEach(op => {
                if (typeof op.insert === 'string') {
                    html += op.insert; // 处理文本
                } else if (op.insert.image) {

                    if (type == 'img') {
                        html += `<yj_image image="${insert}">${op.insert.image}</yj_image>`; // 处理图片
                    } else if (type == 'video') {
                        html += `<yj_video video="${insert}">${op.insert.image}</yj_video>`; // 处理视频
                    }

                }
            });
            console.log(html)
            return html;
        },
        // 将 Delta 模型 转换为自定义 HTML
        convertDeltaModelToCustomHTML: (delta, insertModelObj, insertModelTexture) => {
            let html = '';
            console.log()
            delta.ops.forEach(op => {
                if (typeof op.insert === 'string') {
                    html += op.insert; // 处理文本
                } else if (op.insert.image) {
                    html += `<yj_obj obj="${insertModelObj}" texture="${insertModelTexture}">${op.insert.image}</yj_obj>`; // 处理模型


                }
            });
            console.log(html)
            return html;
        },
        // 将自定义 HTML 转换为 Delta
        convertCustomHTMLToDelta: (html) => {
            const ops = [];
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = html;

            // 处理文本和图片
            Array.from(tempDiv.childNodes).forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    ops.push({ insert: node.textContent }); // 处理文本
                } else if (node.nodeName === 'YJ_IMAGE') {
                    const url = node.getAttribute('image'); // 获取 url 属性
                    ops.push({ insert: { image: node.textContent, insertImage: url } }); // 处理图片
                } else if (node.nodeName === 'YJ_VIDEO') {
                    const video = node.getAttribute('video'); // 获取 video 属性
                    ops.push({ insert: { image: node.textContent, insertVideo: video } }); // 处理视频
                } else if (node.nodeName === 'YJ_OBJ') {
                    const obj = node.getAttribute('obj'); // 获取 obj 属性
                    const texture = node.getAttribute('texture'); // 获取 url 属性
                    ops.push({ insert: { image: node.textContent, insertModelObj: obj, insertModelTexture: texture } }); // 处理视频
                }
            });

            return { ops }; // 返回 Delta 格式
        }

    }
}



export const getInsertUrl = (html, type = "") => {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
    let url = []
    let insertT = []
    console.log(tempDiv)
    // 处理文本和图片
    Array.from(tempDiv.childNodes).forEach(node => {
        if (node.nodeName === 'YJ_IMAGE') {
            const img = node.getAttribute('image'); // 获取 image 属性
            url.push(img)
            insertT.push('img')
        }

        if (node.nodeName === 'YJ_VIDEO') {
            const video = node.getAttribute('video'); // 获取 video 属性
            url.push(video)
            insertT.push('video')
        }

        if (node.nodeName === 'YJ_OBJ') {
            const obj = node.getAttribute('obj'); // 获取 obj 属性
            const texture = node.getAttribute('texture'); // 获取 obj 属性

            const data = {
                obj,
                texture
            }

            url.push(data)
            insertT.push('obj')
        }
    });

    return {
        url,
        insertT
    }
}




export const loopWithAsyncAwait = async (list, callback) => {
    for (let i = 0; i < list.length; i++) {
        await callback(list[i]);
    }
};




export const resImage = (input) => {


    // const regex = /<yj_image\s+image="([^"]+)">([^<]+)<\/yj_image>/;

    // 使用正则表达式替换为 <img> 标签
    // const output = input.replace(regex, (match, imageUrl, textUrl) => {
    //     // 使用标签内的文本 URL（即 <yj_image> 内的 URL）替换
    //     return `<img src="${textUrl}"  style="width: 20px;height: 20px;cursor: grab"/>`;
    // });

    console.log(input)
    if (!input) {
        return ''
    }

    const regex = /<yj_image\s+([^>]+)><\/yj_image>/g;
    let output = input.replace(regex, (match, attributes) => {
        // 将 attributes 按空格拆分为键值对数组
        let attrString = attributes.split(/\s+/).map(attr => {
            return ` ${attr}`;  // 处理每个属性
        }).join('');

        // 替换为 <img> 标签，原始的 image 属性转换为 src 属性
        return `<img${attrString} />`;
    })


    return output.replace(/<br\s*\/?>/gi, '')
}

export const resHtml = (input) => {
    if (!input) {
        return ''
    }

    const regex = /<img\s+([^>]+)\s*\/?>/g;

    // 替换函数：将 <img> 标签转换为 <yj_image> 标签
    let output = input.replace(regex, (match, attributes) => {
        // 将 attributes 按空格拆分为键值对数组
        let attrs = attributes.split(/\s+/);

        // 创建一个新的属性字符串
        let yjAttributes = attrs.map(attr => {
            // 如果是 src 属性，转换为 image 属性
            // if (attr.startsWith('src=')) {
            //     return 'image="' + attr.split('=')[1].replace(/"/g, '') + '"';  // 去掉引号并转换为 image
            // }
            return attr;  // 保持其他属性不变
        }).join(' ');

        // 返回转换后的 <yj_image> 标签
        return `<yj_image ${yjAttributes}></yj_image>`;
    });

    return output.replace(/<br\s*\/?>/gi, '')
}


export const cleanedContent = (content) => {
    console.log(content)
    if (!content) {
        return ''
    }

    let cleaned = content.replace(/<img[^>]*>/g, "");
    // 使用正则提取所有 asseturl 属性的值
    let assetUrls = [];
    let assetType = '';
    let regex = /asseturl="([^"]+)"/g;
    let regexType = /assettype="([^"]+)"/g;
    let match;

    while ((match = regex.exec(content)) !== null) {
        assetUrls = match[1].split(',')
    }

    while ((match = regexType.exec(content)) !== null) {
        assetType = match[1]
    }

    return {
        text: cleaned,
        assetUrls,
        assetType
    }

}



export const processInBatches = async (data, batchSize, fn) => {
    for (let i = 0; i < data.length; i += batchSize) {
        // 获取当前批次的数据
        const batch = data.slice(i, i + batchSize);

        // 并发处理当前批次
        await Promise.all(batch.map(async (item) => {
            // 处理每条数据的异步操作
            await fn(item);
        }));
    }
}




export const getLastValidText = (array) => {
    for (let i = array.length - 1; i >= 0; i--) {
        if (array[i].text && array[i].type == 'gpt') {
            return array[i].text;
        }
    }
    return null; // 如果没有找到有值的 text，则返回 null
};




export const dataURLtoFile = (dataurl, filename) => {
    const arr = dataurl.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]); // base64 解码
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
}



